import React from 'react'
import List from '../../core-components/List'
import { mergeClasses } from '../../utils'

export default function SidePanelList({ classes, ...props }) {
  return <List classes={mergeClasses(classes)} disablePadding {...props} />
}
